import {SubtaskUtil} from '@extensions/subtask-util'
import {toJS} from 'mobx'
import {Hub, SubtaskList} from 'yougile-model'

export const addTaskToSubTasks = (parentTask: Hub, task: Hub): SubtaskList => {
  const subTask = parentTask.data.subtaskList || {order: [], subtasks: {}}
  const subTaskList = SubtaskUtil.addSubtasks(subTask, [task])
  parentTask.data.subtaskList = toJS(subTaskList)
  parentTask.commit()
  return subTaskList
}
